export const aciStar = {
    iconName: 'star',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M12 19.265l-6.923 3.64 1.323-7.71L.8 9.738l7.739-1.124 3.46-7.013 3.462 7.013L23.2 9.737l-5.6 5.459 1.322 7.708L12 19.264z',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
